import { HTTP_STATUS_CODE, IHttpGet } from "../../adapters/http";
import { IRequestDTO, IResponseDTO } from './dto';
import {
  IFundStats,
  IGetAssetColorRepo,
  IGetAssetMemory,
  ISetAssetMemory
} from "../../interfaces";

export class ComparisonFundStatsUseCase {
  constructor (
    private readonly url: string,
    private readonly http: IHttpGet<IFundStats>,
    private readonly fundColorRepo: IGetAssetColorRepo,
    private readonly fundMemoryRepo: IGetAssetMemory<IFundStats> & ISetAssetMemory<IFundStats>,
  ){}

  public async execute({ fundsIds }: IRequestDTO): Promise<IResponseDTO> {
    const fundsIdsWithNoRepeatValues = [...new Set(fundsIds)];

    const fundsStats = await Promise.all(fundsIdsWithNoRepeatValues.map(async (id) => {
      const fundInMemory = this.fundMemoryRepo.get(id);

      if (fundInMemory) {
        return fundInMemory;
      }

      const { statusCode, body } = await this.http.get({
        url: `${this.url}/${id}/comparison`,
      });

      if (statusCode === HTTP_STATUS_CODE.ok) {
        const newFund = {
          ...body,
          id
        };

        const { positive_months, negative_months } = newFund.stats;
        const positive_months_percent =
          (positive_months /
            (positive_months + negative_months)) *
          100;
        const negative_months_percent =
          (negative_months /
            (positive_months + negative_months)) *
          100;

        this.fundMemoryRepo.set(id, {
          ...newFund,
          stats: {
            ...newFund.stats,
            positive_months_percent,
            negative_months_percent
          }
        });

        return {
          ...newFund,
          stats: {
            ...newFund.stats,
            positive_months_percent,
            negative_months_percent
          }
        };
      }

      return null;
    }));

    const fundsStatsWithoutNullValues = fundsStats.filter(Boolean);

    const fundsStatsWithColor = fundsStatsWithoutNullValues.map((asset) => ({
      ...asset,
      color: this.fundColorRepo.getColor(asset.id)
    }));

    return {
      fundsStats: fundsStatsWithColor,
    };
  }
}
